import {Injectable} from '@angular/core';
import {BaseService} from '@core/service/base.service';
import {UrlConstant} from '@shared/constants/url.constant';
import {EditMenuRequest} from '@modules/administration/menus/interfaces/menu.request';

@Injectable()
export class MenuService extends BaseService {
  readonly prefixUrl =  UrlConstant.MENU.PREFIX;

  public getList() {
    return this.get(this.prefixUrl + UrlConstant.MENU.LIST);
  }

  public getMenusByCurrentUser() {
    return this.get(this.prefixUrl  + UrlConstant.MENU.LIST_BY_CURRENT_USER);
  }

  public getListByTree(search: string, type: number) {
    search = search != null ? search.trim() : "";
    return this.get(this.prefixUrl + UrlConstant.MENU.SEARCH_BY_NAME, {params: {name: search, type: type}});
  }

  public getMenu(menuId: number) {
    return this.get(this.prefixUrl + UrlConstant.MENU.GET_MENU_BY_ID.replace("{menuId}", menuId.toString()));
  }

  public addMenu(menu: EditMenuRequest){
    return this.post(this.prefixUrl + UrlConstant.MENU.CREATE, menu);
  }

  public updateMenu(menu: EditMenuRequest){
    return this.post(this.prefixUrl + UrlConstant.MENU.UPDATE, menu);
  }

  public unOrAssignRole(menuId: number, role: string){
    return this.post(this.prefixUrl + UrlConstant.MENU.UN_OR_ASSIGN_ROLE.replace("{menuId}",
      menuId.toString()),null, {params: {role:role}});
  }

  public deleteMenu(menuId: number) {
    return this.delete(this.prefixUrl + UrlConstant.MENU.DELETE_BY_ID.replace("{menu_id}", menuId + ""));
  }
}
